export default {
  title: "Операциялар тарихы",
  number: "Нөмір",
  entityName: "Ұйым атауы",
  type: "Операция түрі",
  typeBuyTariff: "Тариф сатып алу",
  typeAddBalance: "Балансты толықтыру",
  typePaymentAct: "Акт бойынша төлем",
  typePaymentAcceptance: "Тестік төлемді төлеу",
  amount: "Сома",
  currency: "Валюта",
  date: "Күні мен уақыты",
  noHistory: "Сіздің тарихыңыз бос",
  operationsTab: "Барлық операциялар",
  processingTab: "RC Processing",
  reward: "Сыйақы",
  paidFromPurchase:
    "{cash} {currency} төленді <span>(сатып алу {amount} {currency} сомасынан)</span>",
  downloadModal: {
    title: "Файлды жүктеу",
    fileType: "Файл түрі",
    sendOnEmail: "Көшірмесін поштаға жіберу",
    CPUnloadingOperationHistory: "(КП) Операциялар тарихын шығару",
  },
  couldntCreateUnloading: "Тиеп алуды жасау мүмкін болмады",
  giftCard: "Сыйлық картасы",
  orderNumber: "Тапсырыс нөмірі",
  paymentMethod: "Төлем тәсілі",
  inCheckSpecifiedPercentAndSumAward:
    "Чекте жалпы пайыз бен сыйақы сомасы көрсетілген.",
  itsMayNotMatchWithFactSum:
    "Бұл нақты есептен шығарылған ұпайлар сомасына сәйкес келмеуі мүмкін, себебі ол сатып алған клиенттің түріне (ішкі немесе сыртқы), сондай-ақ оның тарифіне байланысты.",
};
